import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'barnyard/layouts';
import Header from './core/components/Header';

const classNamePrefix = 'Accounts--Root';

class Root extends Component {
  render() {
    return (
      <div className={classNamePrefix}>
        <Header {...this.props} />
        <Container className={`${classNamePrefix}__body`}>
          { this.props.children }
        </Container>
      </div>
    );
  }
}

Root.propTypes = {
  children: PropTypes.node,
};

export default Root;
